import { render, staticRenderFns } from "./ShowNotifications.vue?vue&type=template&id=b1a7c1f6"
import script from "./ShowNotifications.vue?vue&type=script&lang=js"
export * from "./ShowNotifications.vue?vue&type=script&lang=js"
import style0 from "./ShowNotifications.vue?vue&type=style&index=0&id=b1a7c1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports